import Image from 'next/image';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { s3Url } from '@components/config/helpers';
import useGlobalSettings from '@components/_hooks/useGlobalSettings';

const HomeSliderImage = ({ slide, idx }) => {
    const { getSetting } = useGlobalSettings();
    const sliderFontColor = getSetting('slider_font_color', '#ffffff');
    const sliderBgOpacity = getSetting('slider_bg_opacity', '0.3');
    const hasText = (slide.title_1 && slide.title_1.trim())
        && (slide.text_1 && slide.text_1.trim())
        && (slide.title_2 && slide.title_2.trim()) ? true : false;

    return (
        <Box
            sx={{
                position: 'relative',
                width: '100%',
                maxWidth: '1920px',
                overflow: 'hidden',
                ...(hasText) ?
                    { height: 260 } :
                    { height: 'auto', paddingBottom: '18%' }
            }}
        >
            <Image
                key={slide.image}
                src={s3Url(slide.image)}
                alt={slide.alt_tag || slide.name}
                fill
                style={{ objectFit: 'cover' }}
                quality={75}
                priority={idx === 0}
                sizes="(max-width: 1080px) 100vw, 1920px"
            />
            {hasText && (
                <Box
                    sx={{
                        position: 'absolute',
                        left: { xs: 24, md: 80 },
                        top: '50%',
                        transform: 'translateY(-50%)',
                        zIndex: 1,
                        maxWidth: 650,
                        display: 'flex',
                        flexDirection: 'column',
                        px: { xs: 2, md: 3 },
                        py: { xs: 2, md: 1 },
                        border: '2px solid',
                        borderColor: 'primary.main',
                        borderRadius: 2,
                        color: sliderFontColor,
                        backgroundColor: `rgba(00, 00, 00, ${sliderBgOpacity})`,
                    }}
                >
                    <Typography variant="span" sx={{ fontWeight: 400 }}>
                        {slide.title_1}
                    </Typography>

                    <Typography
                        component="span"
                        sx={{
                            fontSize: { xs: 44, md: 72 },
                            lineHeight: 0.95,
                            fontWeight: 800,
                            letterSpacing: '-2px',
                        }}
                    >
                        {slide.title_2}
                    </Typography>


                    <Typography
                        component="p"
                        sx={{
                            mt: 1.5,
                            fontSize: { xs: 15, md: 18 },
                            fontStyle: 'italic',
                            lineHeight: 1.45,
                            maxWidth: 560,
                        }}
                    >
                        {slide.text_1}
                    </Typography>
                </Box>
            )}
        </Box>
    );
};

export default HomeSliderImage;
